module.exports = __webpack_public_path__ + "static/media/No_Image_Available.625d1aff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/No_Image_Available.jpg
// module id = 183
// module chunks = 0